import { render } from "./MineDashbord.vue?vue&type=template&id=21ec3bee"
import script from "./MineDashbord.vue?vue&type=script&lang=js"
export * from "./MineDashbord.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__